import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { Alert, Modal, Typography } from 'antd';
import styles from 'styles/components/inviteYourFriends.module.scss';

// const postExample = `Backlink Building: Are You Doing It Right in 2025? 🤔 🙅

// As SEO professionals, we know that backlinks are still one of the strongest ranking signals in Google’s algorithm.

// 𝐁𝐮𝐭 𝐡𝐞𝐫𝐞'𝐬 𝐭𝐡𝐞 𝐤𝐢𝐜𝐤𝐞𝐫: 𝐍𝐨𝐭 𝐚𝐥𝐥 𝐛𝐚𝐜𝐤𝐥𝐢𝐧𝐤𝐬 𝐚𝐫𝐞 𝐜𝐫𝐞𝐚𝐭𝐞𝐝 𝐞𝐪𝐮𝐚𝐥.

// Spammy backlinks can damage your site’s authority.

// That’s why getting quality, niche-specific backlinks from trusted sources is more important than ever.

// I recently came across KarmaLinks.io, and it’s made backlink building a whole lot smarter. It helps SEO teams build real, relevant connections without the usual hassle.

// Here’s why I think KarmaLinks is a 𝐦𝐮𝐬𝐭-𝐭𝐫𝐲:

// ✅ Karma Credit System: You give backlinks to earn credits, creating a true give-and-take, promoting fairness and reciprocity.

// ✅ Give & Receive Backlinks: A streamlined, transparent process to build backlinks only with trusted, verified websites in your niche.

// ✅ Automated Requests: Say goodbye to manual outreach. KarmaLinks makes the process easy and efficient.

// ✅ Niche-Relevant Matches: You're only matched (80%) with sites that actually make sense for your industry.

// ✅ Spam-Free & Verified Domains: All domains are carefully vetted, ensuring you're exchanging links with genuine, high-authority sites.

// I’ve personally found Karma Links to be a huge asset for my backlink strategy. It's not about quick fixes; it’s about building natural, ethical connections that actually matter in the long run.

// If you’ve tried hashtag#KarmaLinks, what's your experience?

// If not, I highly recommend checking it out.

// 👉 Free Registration Link is in the first comment`;

// const postExample2 = `I just joined a secret club of founders and marketers exchanging backlinks — and it’s an absolute game changer.

// No shady directories.
// No cold outreach.
// No begging for backlinks.

// Just real people helping each other rank.

// It’s called KarmaLinks and it’s hands-down the most honest backlink exchange I’ve seen.

// Here’s how it works:
// 👉 You give a quality backlink to someone in the community
// 👉 You earn “karma”
// 👉 You spend that karma to get backlinks for your own site

// Fair. Transparent. Smart.
// (And yeah, 100x better than sending 500 “can I get a backlink?” emails.)

// If you're serious about SEO growth, this is your backdoor in.
// Join before it gets crowded: https://karmalinks.io

// 💬 Curious to hear your thoughts — would you try this?`;
// const postExample3 = `Backlinks are one of the hardest parts of SEO.
// Not because they’re complicated but because they take relationships.

// Now imagine a system where:
// ✅ Every backlink you give earns you real value
// ✅ You only link to high-quality content you believe in
// ✅ Your contributions come back around — tracked, visible, and fair

// No spam. No awkward outreach. No weird link swaps.
// Just a network of founders, marketers, and creators who actually want to help each other grow.

// That’s exactly what KarmaLinks is doing.`;
// const items = [
//   {
//     key: '1',
//     label: <span>Example post 1</span>,
//     children: (
//       <div>
//         <Input.TextArea rows={8} value={postExample} disabled />
//         <Button
//           style={{ marginTop: 8 }}
//           type="primary"
//           icon={<CopyOutlined />}
//           onClick={() => {
//             navigator.clipboard.writeText(postExample);
//             message.success('Linkedin post example copied');
//           }}
//         >
//           Copy Linkedin post example
//         </Button>
//       </div>
//     ),
//   },
//   {
//     key: '2',
//     label: <span>Example post 2</span>,
//     children: (
//       <div>
//         <Input.TextArea rows={8} value={postExample2} disabled />
//         <Button
//           style={{ marginTop: 8 }}
//           type="primary"
//           icon={<CopyOutlined />}
//           onClick={() => {
//             navigator.clipboard.writeText(postExample2);
//             message.success('Linkedin post example copied');
//           }}
//         >
//           Copy Linkedin post example
//         </Button>
//       </div>
//     ),
//   },
//   {
//     key: '3',
//     label: <span>Example post 3</span>,
//     children: (
//       <div>
//         <Input.TextArea rows={8} value={postExample3} disabled />
//         <Button
//           style={{ marginTop: 8 }}
//           type="primary"
//           icon={<CopyOutlined />}
//           onClick={() => {
//             navigator.clipboard.writeText(postExample3);
//             message.success('Linkedin post example copied');
//           }}
//         >
//           Copy Linkedin post example
//         </Button>
//       </div>
//     ),
//   },
// ];

export const shareKarmaLinksModalFunction = (inviteCode) => {
  Modal.info({
    width: 550,
    okText: 'Close',
    title: 'Share KarmaLinks and earn 100 KarmaPoints per signup',
    content: (
      <div>
        <div style={{ marginBottom: 12 }}>
         Refer KarmaLinks to other B2B SaaS and earn 100 KarmaPoints per signup.
          <br />
          Get 1,000 KarmaPoints by generating only 10 signups.
        </div>
        {/* <h3 style={{ marginBottom: 2 }}>Linkedin post examples</h3> */}

        {/* <Tabs defaultActiveKey="1" items={items} /> */}
        <h3 style={{ marginBottom: 2 }}>
          Make sure people use your referral link
        </h3>
        <div className={styles.link}>
          <Typography.Text
            copyable={{
              text: `https://karmalinks.io/?ref=${inviteCode}`,
              icon: [
                <span style={{ color: '#08a87f' }}>
                  <CopyOutlined key="copy-icon" />
                  &nbsp;Copy
                </span>,
                <span>
                  <CheckOutlined key="copied-icon" />, &nbsp;copied
                </span>,
              ],
            }}
            code
          >
            {`https://karmalinks.io/?ref=${inviteCode}`}
            &nbsp;
          </Typography.Text>
        </div>
        <br />
        <br />
        <Alert
          type="info"
          showIcon
          description="Earn KarmaPoints when a referred business gets approved. Eligible businesses must have a Domain Rating (DR) above 15 and create 1 backlink."
        />
      </div>
    ),
  });
};
